// extracted by mini-css-extract-plugin
module.exports = {"prosThink":"prosThink_prosThink__GuGSF"};